import React from "react";

// The help line under the MFA login step. docs/specs/mfa-ux-cleanup.md §4 (Row 2, option A): on the authenticator
// step only, a lost-phone line takes the bold line's place (support resets the authenticator; we offer no other
// path). Every other step keeps today's bold line, word for word.
const MfaHelpLine = ({ method }) =>
  method === "totp" ? (
    <p className="pb-4">Lost your phone? Call support at 888-587-9757.</p>
  ) : (
    <p className="fw-bold pb-4">
      Please log in with your registered email address. If you need assistance please call 888-587-9757
    </p>
  );

export default MfaHelpLine;
